import { Typography, Box, Stack } from "@mui/material";
import React from "react";

interface RadioSelectorProps {
  rooms: Array<{ numero: string; label: string; image: string }>;
  selectedRooms: string[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioSelector: React.FC<RadioSelectorProps> = ({
  rooms,
  selectedRooms = [],
  onChange,
}) => {
  return (
    <Stack>
      {rooms.map((room) => (
        <div key={room.numero}>
          <Box pb={2} display={"flex"} alignItems="center">
            <input
              type="checkbox"
              id={`room${room.numero}`}
              name="room"
              value={room.numero}
              checked={selectedRooms.includes(room.numero)}
              onChange={onChange}
              style={{ marginRight: "10px" }} // Optional for spacing
            />
            <label htmlFor={`room${room.numero}`} style={{ cursor: "pointer" }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "18px",
                  fontFamily: "degular",
                  letterSpacing: 1.3,
                }}
              >
                {room.label}
              </Typography>
            </label>
          </Box>
        </div>
      ))}
    </Stack>
  );
};

export default RadioSelector;
